import { Component, OnInit } from '@angular/core';
import { DoctorProfileInformation } from '../../../classes/doctor_profile_information'
import { DoctorProfileService } from 'src/app/services/Modules/doctorProfile.service';
import { AuthService } from 'src/app/services/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/Modules/user.service';
import { Location } from '@angular/common';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { MatTableDataSource } from '@angular/material/table';
import {ENVIRONMENT} from '../../../../app/includes/global'
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as global from "../../../includes/global";
import { CommonService } from 'src/app/services/common.service';
import { TITLES } from 'src/app/constants/userTitles.constants';

@Component({
  selector: 'app-doctor-profile-information',
  templateUrl: './doctor-profile-information.component.html',
  styleUrls: ['./doctor-profile-information.component.css']
})
export class DoctorProfileInformationComponent implements OnInit {
  public provider_titles = TITLES;
  global = global;
  model: DoctorProfileInformation;
  currentUser: any;
  companyId: any;
  isIRCCompany: boolean;
  supervisingProvider = '';
  supervisingProviderTrueRCMID = '';
  company: any;
  companyType: any;
  allPermissions:any;
  displayedColumns: string[] = ['code', 'title', 'operation'];
  dataSource: any = new MatTableDataSource([])
  dataSourceUser:any=new MatTableDataSource([]);
  selectedUser: any;
  env=ENVIRONMENT;
  hidePermissions: boolean = false;
  selectedUserType;
  titleControl = new FormControl();
  displayProviderFn(title): string {
    return title;
  }
  titles = ["M.D.", "D.O.", "PA-C", "ARNP", "R.N.", "N.P.", "P.A.", "L.Ac", "DNP", "CWS", "CWSP", "WOCN"]
  providerDropdownSettings: any = {};

  constructor(private doctorProfileService: DoctorProfileService,
    private authService: AuthService,
    private companyService: CompanyService,
    private loader: NgxUiLoaderService,
    private route: ActivatedRoute,
    private userService: UserService, 
    private toastr: ToastrService,
    private _location: Location,
    private commonService: CommonService) {
    this.model = new DoctorProfileInformation();
    this.currentUser = this.authService.currentUser;
    this.companyId = this.route.parent.parent.snapshot.params.id;
    // if (this.companyId === '60c0bb216f04165c099f7c33' || this.companyId === '5f69d0651b1eba8bee2d3ac4') {
    //   this.isIRCCompany = true;
    // }
    this.providerDropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'full_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
  };
  }
  doctorProfileInformationLoader = 'doctor-profile-information-loader';

  async ngOnInit() {
    await this.getCompanyName();
    if (this.company.company_type !== 'Wound') {
      this.isIRCCompany = true;
      console.log('this.isIRCCompany = true',this.isIRCCompany);
  }
    const provider_id = this.route.snapshot.paramMap.get('provider_id');
    const filter = {
      _id: provider_id,
      is_activated: "false"
    }
    const projection = {
      user_type: 1,
      first_name: 1,
      last_name: 1,
      email: 1,
      title: 1,
      mobile: 1,
      trueRCMID: 1,
      secondary_phone: 1,
      secondary_email_address: 1,
      permission:1,
      tin:1
    }
    const userResponse: any = await this.userService.getUser(filter, projection).subscribe((response: any) => {
      if (response.status === 200) {
        this.selectedUser = response.data;
        this.selectedUserType = this.selectedUser.user_type.toLowerCase();
        if(this.selectedUserType == global.USER_TYPE.DOCTOR) {
          this.titles = this.provider_titles;
        }
        if (this.selectedUserType == 'medical_assistant' || this.selectedUserType === 'nurse') {
          this.hidePermissions = true;
        }
        this.initProfile(response.data);
      }
    });



  }

  async getCompanyName() {
    const companyName = await this.companyService.getCompanyName(this.companyId).toPromise()
    this.company = companyName.data;
  }

  goBack() {
    this._location.back();
  }

  initProfile(user) {
    this.model.user_id_ref = user._id;
    this.model.user_type = user.user_type;

    this.loader.startLoader(this.doctorProfileInformationLoader);

    const filter = {
      user_id_ref: user._id
    }
    this.doctorProfileService.getProfile(filter, {}).subscribe((response: any) => {
      if (response.status == 200) {
        console.log('response',response);
        if (!response.data) {
          this.model.first_name = user.first_name;
          this.model.last_name = user.last_name;
          this.model.title = user.title;
          this.model.work_email = user.email;
          this.model.office_phone = user.mobile ? user.mobile : '';
          this.model.trueRCMID = user.trueRCMID ? user.trueRCMID : '';
          this.model.secondary_phone = user.secondary_phone ? user.secondary_phone : '';
          this.model.secondary_email_address = user.secondary_email_address ? user.secondary_email_address : '';
          this.model.npi = user.npi ? user.npi : '';
          this.model.tin = user.tin ? user.tin : '';

        }
        else {

          this.model = response.data;
          this.model.first_name = user.first_name;
          this.model.last_name = user.last_name;
          this.model.title = user.title;
          this.model.work_email = user.email;
          this.model.office_phone = user.mobile ? user.mobile : '';
          this.model.trueRCMID = user.trueRCMID ? user.trueRCMID : '';
          this.model.secondary_phone = user.secondary_phone ? user.secondary_phone : '';
          this.model.secondary_email_address = user.secondary_email_address ? user.secondary_email_address : '';
          this.model.npi = user.npi ? user.npi : '';
          this.model.tin = user.tin ? user.tin : '';
        }

        if(this.model.title){
            this.model.titleArray=this.model.title.split(' , ');
        }
      }
    }, (error) => {
      console.error('Error occured', error.toString());

    }, () => {
      this.loader.stopLoader(this.doctorProfileInformationLoader);
    })
  }
  removePermissionCode(element){

    console.log("element : remve", element);
  }
  addPermissionCode(element){

    console.log("element : add", element);

  }
  checkPermissionCode(element){

    return false;
  }
  handleSubmit(values) {
    let supervisorProviderDetails : any = {};
    if(this.supervisingProvider){
      supervisorProviderDetails.supervisingProvider = this.supervisingProvider;
    }
    if(this.supervisingProviderTrueRCMID){
      supervisorProviderDetails.supervisingProviderTrueRCMID = this.supervisingProviderTrueRCMID;
    }

    const infoToastr = this.toastr.info('Saving Profile Information...', 'Please wait', { disableTimeOut: true });
    this.loader.startLoader(this.doctorProfileInformationLoader);

   

    this.doctorProfileService.saveProfile(this.model,supervisorProviderDetails).subscribe((response: any) => {
    }, (error) => {
      console.error('Error occured', error.toString());
      this.toastr.clear(infoToastr.toastId);
      this.toastr.error("Somethimg Went Wrong", "Failed");
    }, () => {
      this.loader.stopLoader(this.doctorProfileInformationLoader);
    })

    let data = {
      _id: this.model.user_id_ref,
      first_name: this.model.first_name,
      last_name: this.model.last_name,
      title: this.model.title,
      trueRCMID: this.model.trueRCMID,
      secondary_phone : this.model.secondary_phone,
      secondary_email_address : this.model.secondary_email_address,
      npi: this.model.npi,
      tin: this.model.tin,
      company_id: this.company._id
    }
   
    this.userService.updateUser(data).subscribe((response: any) => {

    }, (error) => {
      console.error('Error occured', error.toString());
      this.toastr.clear(infoToastr.toastId);
      this.toastr.error("Somethimg Went Wrong", "Failed");
    }, () => {
      this.loader.stopLoader(this.doctorProfileInformationLoader);
      this.toastr.clear(infoToastr.toastId);
      this.toastr.success("Profile Information Saved Successfully", "Success");
    })
  }
  supervisionCondition(){
    if(! this.model.title) return false;
    if(this.model.title.includes('N.P.')||this.model.title.includes('P.A.')||this.model.title.includes('NP')||this.model.title.includes('PA')){
      return true;
    }else return false;
  }
  allowOnlyText(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 90 && charCode < 97) {
      return false;
    }

    if (charCode < 65 || charCode > 122) {
      return false;
    }
    return true;
  }

  onTitleSelect($event) {
    if(this.model.titleArray&&Array.isArray(this.model.titleArray)){
      this.model.title=this.model.titleArray.join(' , ');
    }else if(this.model.title){
      this.model.title=this.model.titleArray;//.join(', ');
    }
}

onTitleDeSelect($event) {
    if(this.model.titleArray&&Array.isArray(this.model.titleArray)){
      this.model.title=this.model.titleArray.join(' , ');
    }else if(this.model.title){
      this.model.title=this.model.titleArray;//.join(', ');
    }
}
onSelectAllTitle($event) {
    this.model.title=$event;

}
onDeSelectAllTitleAll($event) {
    this.model.title='';
  
}
  shouldShowTitle() {
    if (this.company.company_type.toLowerCase() === 'wound') {
      return true
    }
    else if (this.selectedUserType === global.USER_TYPE.DOCTOR) {
      return true
    }
}
}
